/* tslint:disable */
import {
  KanvasUser,
  OfferCode
} from '../index';

declare var Object: any;
export interface LimitedTimeOfferInterface {
  "id": string;
  "ClaimPin": string;
  "validAt": Date;
  "invalidAt": Date;
  "OfferDescription": string;
  "TextWhenUsed"?: boolean;
  "TextNumber"?: string;
  "kanvasUserId"?: string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  kanvasUser?: KanvasUser;
  offerCodes?: OfferCode[];
}

export class LimitedTimeOffer implements LimitedTimeOfferInterface {
  "id": string;
  "ClaimPin": string;
  "validAt": Date;
  "invalidAt": Date;
  "OfferDescription": string;
  "TextWhenUsed": boolean;
  "TextNumber": string;
  "kanvasUserId": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  kanvasUser: KanvasUser;
  offerCodes: OfferCode[];
  constructor(data?: LimitedTimeOfferInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LimitedTimeOffer`.
   */
  public static getModelName() {
    return "LimitedTimeOffer";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LimitedTimeOffer for dynamic purposes.
  **/
  public static factory(data: LimitedTimeOfferInterface): LimitedTimeOffer{
    return new LimitedTimeOffer(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LimitedTimeOffer',
      plural: 'LimitedTimeOffers',
      path: 'LimitedTimeOffers',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "ClaimPin": {
          name: 'ClaimPin',
          type: 'string'
        },
        "validAt": {
          name: 'validAt',
          type: 'Date'
        },
        "invalidAt": {
          name: 'invalidAt',
          type: 'Date'
        },
        "OfferDescription": {
          name: 'OfferDescription',
          type: 'string'
        },
        "TextWhenUsed": {
          name: 'TextWhenUsed',
          type: 'boolean'
        },
        "TextNumber": {
          name: 'TextNumber',
          type: 'string'
        },
        "kanvasUserId": {
          name: 'kanvasUserId',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        kanvasUser: {
          name: 'kanvasUser',
          type: 'KanvasUser',
          model: 'KanvasUser',
          relationType: 'belongsTo',
                  keyFrom: 'kanvasUserId',
          keyTo: 'id'
        },
        offerCodes: {
          name: 'offerCodes',
          type: 'OfferCode[]',
          model: 'OfferCode',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'limitedTimeOfferId'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/LimitedTimeOffer.ts